export const PAGE_VIEW = 'page_viewed'
export const CLICK = 'clicked'
export const PRODUCT_IMPRESSION = 'product_impression'
export const PURCHASE_PRODUCT = 'purchase_product'
export const PURCHASE_ORDER = 'purchase_order'
